import BaseEntity from '@/entities/BaseEntity';

export default class ProductSet extends BaseEntity {
  id = null;
  name = '';
  product_count = null;

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
